export const isValidTimestamp = (timestamp?: string): boolean => {
  if (!timestamp) return false;

  const regex = /^([01]\d|2[0-3]):([0-5]\d)(:([0-5]\d))?$/;
  return regex.test(timestamp);
};
